







































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Fournisseur} from '@/models';

import CrudFournisseurEditLight from '@/components/Crud/Fournisseur/EditLight.vue';

@Component({
	components: {
		CrudFournisseurEditLight,
	}
})
export default class CrudFournisseurEditDialogLight extends Vue {
	@InOut({ type: Fournisseur  , isVModel: true }) private value!: Fournisseur;

	@Emit()
	private onSubmit(fournisseur: Fournisseur) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
